import { useQuery } from "@tanstack/react-query"
import { getEmployee } from "src/redux/api/employee.api";
import { Employee } from "src/redux/types/_employee.type";

export interface Params {
  employeeCode?: string;
  name?: string;
  email?: string;
}

export const employeesQueryKey = {
  all: ["adm-employees-list"] as const,
  list:(employeeCode?: string, name?: string, email?: string) => [
    ...employeesQueryKey.all, "list", employeeCode, name, email
  ] as const,
};

export const useEmployees = (params: Params) => {
  return useQuery<Employee[]>({
    queryKey: employeesQueryKey.list(
      params.email,
      params.employeeCode,
      params.name,
    ),
    queryFn: () => getEmployee(params),
    enabled: !!params.employeeCode || !!params.email || !!params.name,
    staleTime: 1000 * 60 * 60 * 2,
    gcTime: 1000 * 60 * 60 * 3,
  });
}